import { createSlice } from "@reduxjs/toolkit";

// Cargar el user de localStorage SINCRÓNICAMENTE (no en un useEffect): si no, el
// primer render arranca con user=null y las rutas protegidas redirigen a "/" →
// se pierde el deep-link de la notificación (caía en el selector de cartas).
const loadStoredUser = () => {
  try {
    if (typeof localStorage === "undefined") return null;
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    try { localStorage.removeItem("user"); } catch (e) { /* no-op */ }
    return null;
  }
};

const initialState = {
  user: loadStoredUser(),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      // Guardar correctamente como JSON string
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    clearUser: (state) => {
      // MODO LOCAL: el user sintético (local:true) NO tiene sesión Firebase, así que un
      // onAuthStateChanged residual dispararía clearUser y lo borraría → caería a login
      // offline. Lo protegemos (cinturón; el tirante es no montar el AppBar en IS_LOCAL).
      if (state.user && state.user.local) return;
      state.user = null;
      localStorage.removeItem("user");
    },
    initializeUser: (state) => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        try {
          // Parsear el JSON guardado
          state.user = JSON.parse(storedUser);
        } catch (error) {
          console.error("Error al parsear usuario de localStorage:", error);
          // Si hay error, limpiar el localStorage corrupto
          localStorage.removeItem("user");
          state.user = null;
        }
      }
    },
  },
});

export const { setUser, clearUser, initializeUser } = userSlice.actions;
export const selectUser = (state) => state.user.user;

export default userSlice.reducer;
